import { render, staticRenderFns } from "./businessCooperationPhone.vue?vue&type=template&id=281a04f8&scoped=true"
import script from "./businessCooperationPhone.vue?vue&type=script&lang=js"
export * from "./businessCooperationPhone.vue?vue&type=script&lang=js"
import style0 from "./businessCooperationPhone.vue?vue&type=style&index=0&id=281a04f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281a04f8",
  null
  
)

export default component.exports